import * as angular from 'angular';
import template from './commonReportQueryCriteriaRow.tpl.html';

export default angular.module('aps.directive.commonReportQueryCriteriaRow', [])
  .directive('apsCommonReportQueryCriteriaRow', commonReportQueryCriteriaRowDef)
  .name;

function commonReportQueryCriteriaRowDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    scope: {
      vm: '='
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/reports/commonReportQueryCriteriaRow.directive.ts